const data = [
	{
		Membership: `Life Membership of ISTE`,
	},
	{
		Membership: `Membership of CSI`,
	},
	
];

export default data;
